<h2 mat-dialog-title style="white-space: nowrap">Manage Case for {{selectedUser.userName}}</h2>
<mat-dialog-content>
  <h3 style="margin-top:0px">Selected Account: {{selectedAccountName}}</h3>
  <div class="row" *ngIf="cases && selection">
    <div style="flex: 1 1 0%; box-sizing: border-box;" *ngIf="cases.length !== 0">
      <mat-selection-list class="list" style="text-align: left;" (selectionChange)="changeCaseIds($event)">
        <cdk-virtual-scroll-viewport itemSize="48" style="height:100%">
          <mat-list-option *cdkVirtualFor="let case of cases; templateCacheSize: 0" [value]="case.caseId" [selected]="selection.isSelected(case.caseId)">
            <span matListItemTitle style="display: flex; align-items: center;">{{case.caseName}}</span>
          </mat-list-option>
        </cdk-virtual-scroll-viewport>
      </mat-selection-list>
    </div>
    <div *ngIf="cases.length === 0" style="margin-left: 5px; flex: 1 1 0%; box-sizing: border-box;">
      No case has been created for account
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="submitManageCaseAccessForm" [disabled]="!formChanged" (click)="submit()">Submit</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
